import script from "./Step2OTPVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2OTPVerification.vue?vue&type=script&setup=true&lang=js"

import "./Step2OTPVerification.vue?vue&type=style&index=0&id=df871938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df871938"]])

export default __exports__